import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import Gift from "./Gift";
import SpinWheelForm from "./SpinWheelForm";
import SpinWheelService from "../../Services/SpinWheelService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import GiftEditor from "./GiftEditor";
import SpinWheelFormEditor from "./SpinWheelFormEditor";
import CustomHeading from "../../common/CustomHeading";

const SpinWheelEditor = () => {
  const [spObj, setSpObj] = useState(null); // For Spin Wheel Details
  const [gifts, setGifts] = useState([]); // For Gift Details

  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve existing data from location state (or load via API if needed)
  console.log(location.state.docId)
  const existingSpinWheel = location.state?.spinWheelData.spinWheel || null;
  const existingGifts = location.state?.spinWheelData?.gifts || null;
console.log(existingSpinWheel)
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userUid = userObj?.user?.uid;

  const createdUserDocId= userUid;
  const modifiedUserDocId = userUid

  // Prepopulate data when editing an existing spin wheel
  useEffect(() => {
    if (existingSpinWheel) {
      setSpObj(existingSpinWheel);
    }
    if (existingGifts) {
      setGifts(existingGifts);
    }
  }, [existingSpinWheel, existingGifts]);
  const docId= location.state.docId

  const handleUpdate = async () => {
    if (!gifts || !spObj) {
      showErrorToast("All Fields are mandatory");
      return false;
    }

    try {
      const response = await SpinWheelService.updateSpinWheel(
        docId,
        spObj,
        gifts,
        modifiedUserDocId,
      );
      console.log(response.data);
      navigate(-1, { state: { message: "Spin Wheel updated successfully" } });
    } catch (error) {
      showErrorToast(error.response?.data || "Error updating spin wheel");
      console.error(error.response?.data || error.message);
    }
  };
console.log(gifts)
  const handleBack = () => {
    navigate(-1);
  };

  const updateGiftsDetail = (updatedGifts) => {
    setGifts(updatedGifts);
  };

  const handleSpinWheelData = (sp) => {
    setSpObj(sp);
  };

  return (
    <div className=" bg-appGrayBackground pb-20">
       <AdminAppBar />
      <ToastContainer />
      <div className="pt-24 px-20 xl:px-6 relative flex justify-between gap-5">
        <CustomHeading title={"Edit Spin Wheel"} isIcon={true} />
        <div>
          <button
            onClick={handleUpdate}
            className="whitespace-nowrap bg-customGreen rounded-lg p-1 px-5 w-32 text-lg text-white h-10 text-center"
          >
            Update
          </button>
        </div>
      </div>
      <div className="mt-5 mx-10  grid grid-cols-12 gap-10">
        <div className="col-span-8 bg-white rounded-lg px-5 py-5">
          <GiftEditor  updateGiftsDetail={updateGiftsDetail} initialGifts={existingGifts} />
        </div>
        <div className="col-span-4 bg-white rounded-lg px-5">
          <SpinWheelFormEditor spDetail={handleSpinWheelData} initialSpinWheel={existingSpinWheel} />
        </div>
      </div>
    </div>
  );
};

export default SpinWheelEditor;
